/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {configureAdminResourceStates} from '../common/controller/admin-resource-routing';
import {AdUnitCopyModalComponent} from './ad-unit-copy-modal.component';
import {resetDimensionsBasedOnAdUnitOption} from './ad-unit-commons';
import {adTagLinker} from './ad-tag-linker';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {AdUnitTagResource} from '../../components/api/resources/resource/adunittag.resource';
import {AdUnitResource} from '../../components/api/resources/resource/adunit.resource';



export function adUnitStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('ad-units.ad-unit', AdUnitResource, 'app.inv', 'app');
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'AdUnit',
          editTag: 'adn-ad-unit-edit-page',
          twoPanel: {
            rightTag: 'adn-ad-unit-analysis-page'
          },
          listTag: 'adn-ad-unit-list-page',
          listResolve: {
            extension: /*@ngInject*/ function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();
              const localUserProfile = adnRouterHelper.services.localUserProfile();

              return {
                func: function(ctrl) {
                  ctrl.auFields = ['name', {param: '', label: 'dimensions'}, {label: 'site', param: 'Site'}];
                  if (LocalNetworkInfo.obtain().getSiteCountries().length > 1) {
                    ctrl.auFields.push({label: 'country', param: ''});
                  }
                  ctrl.auFields.push({label: 'status', param: 'requestedInLastDay'});
                  ctrl.auFields.push({label: 'tagId'});
    
                  const isSpecialUser = localUserProfile.get('username') === 'adnuntius@adnuntius.com'
                    || localUserProfile.get('username') === 'broker1@adnuntius.com';
                  if (LocalNetworkProfile.isPureMarketplacePlatform() && isSpecialUser) {
                    ctrl.auFields.push({label: 'isFullPage', param: 'fullPage'});
                  }
                }
              };
            },
            bulk: function() {
              return {
                adTagGenerator: adTagLinker
              };
            }
          },
          itemResolve: {
            tags: /*@ngInject*/ function($stateParams) {
              if ($stateParams.isNew) {
                return Promise.resolve({});
              }
              return adnRouterHelper.services.resource(AdUnitTagResource).get({id: $stateParams.id}).$promise;
            },
            applyTags: /*@ngInject*/ function(model, tags) {
              if (tags && model) {
                model.tags = tags;
              }
            },
            copyConfig: function() {
              return {
                modalComponent: AdUnitCopyModalComponent,
                stateUrl: 'app.inv.ad-units.ad-unit',
                lcase: 'ad unit',
                ucase: 'Ad Unit',
                preCopy(copyModel) {
                  resetDimensionsBasedOnAdUnitOption(copyModel);
                }
              };
            }
          },
          crumbParams: ['EarningsAccount', 'Site']
        });
  }, adnRouterHelper);
}
